<template>
	<Toast />
    <ConfirmDialog/>

	<div class="p-fluid container-box">
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="username">아이디</label>
					<InputText id="username" v-model.trim="user.userId" :readonly= "true" disabled="true"/>
				</div>
				<div class="col">
					<label for="fullNm">이름</label>
					<InputText id="fullNm" v-model.trim="user.userNm" :readonly= "true" disabled="true"/>     
				</div>
			</div>
		</div>
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="userTypeNm">사용자유형</label>
					<InputText id="userTypeNm" v-model.trim="user.userTypeNm" :readonly= "true" disabled="true"/>
				</div>
				<div class="col">
					<label for="custNm">업체명</label>
					<InputText id="custNm" v-model.trim="user.custNm" />
				</div>
			</div>
		</div>
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="dutyGrade">직책명</label>
					<InputText id="dutyGrade" v-model.trim="user.dutyGrade" />
				</div>
				<div class="col">
					<label for="chargeTitle">담당업무</label>
					<InputText id="chargeTitle" v-model.trim="user.chargeTitle" />
				</div>
			</div>
		</div>
		<div class="p-field field p-05">
			<label for="chargeDtl">업무상세</label>
			<InputText id="chargeDtl" v-model.trim="user.chargeDtl" />
		</div>
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="telNo">전화번호</label>
					<InputText id="telNo" v-model.trim="user.telNo" />
				</div>
				<div class="col">
					<label for="faxNo">팩스번호</label>
					<InputText id="faxNo" v-model.trim="user.faxNo" />
				</div>
			</div>
		</div>
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="mobileNo">휴대폰번호</label>
					<InputText id="mobileNo" v-model.trim="user.mobileNo" />
				</div>
				<div class="col">
					<label for="email">이메일</label>
					<InputText id="email" v-model.trim="user.email" />
				</div>
			</div>
		</div>
		<div class="p-field field">
			<div class="grid">
				<div class="col">
					<label for="lastPwdDt">마지막암호변경일자</label>      
					<InputText id="lastPwdDt" v-model.trim="user.lastPwdDt" readonly= "true" disabled="true"/>  
				</div>
				<div class="col">
					<label for="remarks">비고</label>
					<Textarea id="remarks" v-model="user.remarks" required="true" rows="1" />
				</div>
			</div>
		</div>
		<div class="p-05">
			<Button label="저장" class="btn-save" @click="btnAct('SAVE')" />
		</div>
	</div>	
</template>

<script>
import { ref, onMounted } from 'vue';
import { useToast } from 'primevue/usetoast';
import UserService from '@/service/cm/UserService';
import CodeService from '@/service/cm/CodeService';

export default {
	setup() {
		onMounted(() => {
            
			codeService.getCodeList({upCode:'USERGB'}).then(data=>userCds.value = data);
			console.log(userCds);

			user.value = JSON.parse(localStorage.getItem("user")); 

			userService.getOne(user.value.username).then(data => {
				user.value = data;
			});
						
        })
		
        const user = ref({});
        const userService = new UserService();
		const codeService  = new CodeService();
		const toast = useToast();
		const userCds = ref();
		const columns = ref([
            {field: 'username', header: '아이디'},
            {field: 'fullNm', header: '성명'},
            {field: 'empNo', header: '사번'},
            {field: "userGbCd", header:"사용자구분"},
			{field: "useYn", header:"사용여부"},
			{field: "lockedYn", header:"계정장금여부"}
        ]);
		// const photoSrc = ref('');
		// const fileUpload = ref();

		const btnAct = (_act) => {
            switch(_act) {
                case "SAVE":
					saveUser();
                    break;
                default:
					break;
            }
        }

		const saveUser = () => {
			userService.updateOne(user.value.userId, user.value).then(() => {
				toast.add({severity:'success', summary: '저장 완료', detail: '개인정보가 변경되었습니다', life: 3000});
			});			
		}

        return {user , userCds, columns, btnAct, saveUser}
	}
}
</script>

<style lang="scss" scoped>
.container-box {
  width: 600px;
  margin: 50px auto 0;
}

.InputText-label{
	text-align:right; 
	margin-top:auto;
	margin-bottom:auto
}
hr{
	margin-bottom:20px;
}


</style>